// src/pages/ResetPassword.jsx
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../api";
import ConfirmModal from "../components/ConfirmModal";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();

  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (pw1 !== pw2) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    try {
      await api.post("/reset-password", {
        token,
        new_password: pw1,
      });
      setShowModal(true);           // success modal
    } catch (err) {
      console.error(err);
      setError(
        err.response?.status === 400
          ? "Invalid or expired link."
          : "Server error – try again."
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-md mx-auto mt-24 p-6 bg-white rounded-xl shadow">
      <h1 className="text-2xl font-bold mb-6 text-center">Reset password</h1>

      <form onSubmit={handleSubmit}>
        <input
            type="password"
            placeholder="New password"
            value={pw1}
            onChange={(e) => setPw1(e.target.value)}
            className="w-full mb-4 p-3 border rounded bg-white text-black placeholder-gray-500"
            required
            />
            <input
            type="password"
            placeholder="Repeat password"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            className="w-full mb-6 p-3 border rounded bg-white text-black placeholder-gray-500"
            required
            />

        <button
          type="submit"
          disabled={busy}
          className={`w-full p-3 rounded text-white font-semibold ${
            busy ? "bg-gray-400" : "bg-amber-500 hover:bg-amber-600"
          }`}
        >
          {busy ? "Updating…" : "Set new password"}
        </button>
      </form>

      {error && <p className="text-red-500 mt-4 text-sm">{error}</p>}

      <ConfirmModal
        isOpen={showModal}
        title="Password updated"
        message="You can now log in with your new password."
        confirmText="Go to login"
        hideCancel
        onConfirm={() => navigate("/login", { replace: true })}
        onCancel={() => navigate("/login", { replace: true })}
      />
    </div>
  );
}
